import styled from 'styled-components';
import { getPackageGradient } from './ActivePackageCard.helpers';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const Card = styled.article<{ $packageName: string }>`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 150px;
  padding: 20px;
  border-radius: 21px;
  background: ${({ $packageName }) => getPackageGradient($packageName)};
  box-shadow: 0 4px 21px 2px rgba(0, 0, 0, 0.04);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 18px;
`;

export const DetailsButton = styled(Button).attrs({
  appearance: 'transparent',
  shape: 'square',
  height: 24,
  hasPadding: false,
})`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Title = styled(Typography.Body).attrs({ $variant: '6' })``;

export const Label = styled(Typography.Body)`
  overflow: hidden;
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PackageDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
`;

export const Date = styled(Typography.Body).attrs({ $variant: '4' })`
  font-weight: 500;
  white-space: nowrap;
`;

export const RenewButton = styled(Button).attrs({
  appearance: 'secondary',
})`
  height: 44px;
  margin-top: auto;
  border: 1px solid ${({ theme }) => theme.palette.secondary.labels};
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 40px;
    margin-top: 15px;
    font-size: 15px;
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.palette.quartenary.background};
    }
  }
`;
